<template>
    <div class="settlement-tab-content">
        <div class="search-form-area">
            <el-form label-width="110px" style="padding:10px 5px 0px;" ref="loginFormRef" :model="form"
                @keyup.enter.native="getDataList()">
                <el-row>
                    <el-col :md="12" :lg="6">
                        <el-form-item label="结算申请编号:" prop="dealCode"><el-input style="width: 100%;"
                                v-model="form.dealCode" placeholder="结算申请编号" clearable></el-input></el-form-item>
                    </el-col>

                    <el-col :md="12" :lg="12">
                        <el-form-item label="结算金额:">
                            <el-input v-model="form.money1" placeholder="结算金额" style="width: 48%"></el-input>
                            <span style="width:4%;text-align: center;display: inline-block;">~</span>
                            <el-input v-model="form.money2" placeholder="结算金额" style="width: 48%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12" :lg="6">
                        <!-- <el-form-item label="申请时间:" >
                            <el-date-picker
                                    style="width: 100%"
                                    v-model="form.dealMonth"
                                    placeholder="输入申请时间"
                                    value-format="yyyy-MM"
                                    type="month"
                            ></el-date-picker>
                        </el-form-item> -->
                        <el-form-item label="支付时间:">
                            <el-date-picker style="width: 100%" v-model="form.paymentDate" placeholder="输入支付时间"
                                value-format="yyyy-MM" type="month"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12" :lg="6">
                        <el-form-item label="发布方:">
                            <el-input style="width: 100%;" v-model="form.dealBody" placeholder="请输入发布方名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12" :lg="6" v-if="this.$store.state.user.isSourceOfTax != 1">
                        <el-form-item label="税源地:" prop="bodyId">
                            <el-select v-model="form.bodyId" placeholder="请选择" style="width:100%" clearable filterable>
                                <el-option v-for="item in bodyPageList" :key="item.id"
                                    :label="`${item.bodyName}-${item.abbreviation}`" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12" :lg="12">
                        <el-form-item label="申请时间:">
                            <el-date-picker :picker-options='pickerStartOptions(form.endDate)' style="width: 48%"
                                v-model="form.startDate" placeholder="开始时间" type="date" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"></el-date-picker>
                            <span style="width:4%;text-align: center;display: inline-block;">~</span>
                            <el-date-picker :picker-options='pickerEndOptions(form.startDate)' style="width: 48%"
                                v-model="form.endDate" placeholder="结束时间" type="date" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>

                    </el-col>
                    <el-col :md="12" :lg="6">
                        <el-form-item label="任务大类:">
                            <el-select style="width: 100%;" v-model="form.taskType" placeholder="请选择任务大类" clearable
                                filterable>
                                <el-option v-for="item in taskList" :key="item.ticketProId"
                                    :value="item.ticketProject"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :md="24" :lg="18">
                        <el-form-item label-width="0px">
                            <div style="text-align: right; margin-right: 4vw">
                                <el-button type="primary" @click="handleQuery()">查询</el-button>
                                <el-button type="info" @click="handleReset">重置</el-button>
                            </div>
                        </el-form-item>

                    </el-col>
                </el-row>
            </el-form>
        </div>
        <el-table ref="refTable" :height="tableHeight" style="border-top: 2px solid #ccc" :data="tableData" :show-summary="true"
            :summary-method="getSummaries" @selection-change="handleSelectionChange">
            <el-table-column type="selection" header-align="center" align="center" width="50" class-name="selection">

            </el-table-column>
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="dealCode" label="结算申请编号" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center">
                <template slot-scope="scope">
                    <el-button type="text" class="el_hover_dectrion" size="small"
                        @click="goTaskInfo(scope.row.taskId)">{{ scope.row.taskCode }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="contractCode" label="合同编号" header-align="center" align="center">
                <template slot-scope="scope">
                    <el-button type="text" class="el_hover_dectrion" size="small"
                        @click="infoHandle(scope.row)">{{ scope.row.contractCode }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="taskTypeName" label="任务大类" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="publishName" label="发布方" header-align="center" align="center"></el-table-column>
            <el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="payee" label="收款方信息" header-align="center" align="center">
                <template slot-scope="scope">
                    <span style="color:#3A7DD1;cursor: pointer;" class="el_hover_dectrion"
                        @click="handleSee(scope.row)">查看</span>

                </template>
            </el-table-column>
            <el-table-column prop="money" label="结算总额" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="amountPayable" label="企业应付金额" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="serviceCharge" label="综合服务费" header-align="center" align="center"></el-table-column>
            <el-table-column prop="preTaxAmount" label="税前金额" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="personalTaxAmount" label="个税" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="vatTaxAmount" label="增值税" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="additionalTaxAmount" label="增值附加税" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="individualAmount" label="个人实际收款金额" header-align="center" align="center">
        </el-table-column>
            <el-table-column prop="earnestAmount" label="保证金" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
			<template slot-scope="scope">
				<span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
			</template>
			</el-table-column>
            <el-table-column prop="status" label="交易状态" header-align="center" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿</el-tag>
                    <el-tag v-if="scope.row.status == 1" size="small" type="warning">待审核</el-tag>
                    <el-tag v-if="scope.row.status == 2" size="small">待支付</el-tag>
                    <el-tag v-if="scope.row.status == 3" size="small" type="success">已支付</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="reviewer" label="审核人" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="updateDate" label="申请时间" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="paymentDate" label="支付时间" header-align="center" align="center">
            </el-table-column>
        </el-table>
        <el-pagination background :current-page="pageObject.page" :page-sizes="[10, 20, 50, 100]"
            :page-size="pageObject.limit" :total="pageObject.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handlePageSize" @current-change="handleCurrentPage">
        </el-pagination>
    </div>
</template>
<script>
import { addDynamicRoute } from "../../../../../router/index";
import ArrayUtils from "../../../../../utils/ArrayUtils";

export default {
    data() {
        return {
            tableHeight: 400,
            pickerStartOptions(endTime) {
                return {
                    disabledDate(time) {
                        if (endTime) {
                            // 拼接 00:00:00 是为了统一日期从0点开始 
                            return time.getTime() > new Date(endTime + ' 00:00:00').getTime();
                        }
                    }
                }
            },
            pickerEndOptions(startTime) {
                return {
                    disabledDate(time) {
                        if (startTime) {
                            // 拼接 00:00:00 是为了统一日期从0点开始 
                            return time.getTime() < new Date(startTime + ' 00:00:00').getTime();
                        }
                    }
                }
            },
            bodyPageList: [],
            taskList: [],
            form: {
                bodyId: '',
                dealMonth: '',
                taskType: '',
                money1: '',
                money2: '',
                dealCode: '',
                dealBody: '',
                status: 3,
                startDate: '',
                endDate: ''
            },
            dataList: [],
            //                分页器参数
            pageObject: {
                page: 1,
                limit: 10,
                total: 0,
            },
            countNum: {}
        }
    },
    components: {},
    watch: {},
    computed: {
        tableData() {
            return this.dataList.map(item => {
                return {
                    ...item,
                    taskType: ArrayUtils.getItemBy(this.taskList, 'ticketProject', item.taskType).ticketProject,
                    money: item.money ? item.money.toFixed(2) : '',
                    amountPayable: item.amountPayable ? item.amountPayable.toFixed(2) : '',
                    serviceCharge: item.serviceCharge ? item.serviceCharge.toFixed(2) : '',
                    preTaxAmount: item.preTaxAmount ? item.preTaxAmount.toFixed(2) : '',
                    personalTaxAmount: item.personalTaxAmount ? item.personalTaxAmount.toFixed(2) : '',
                    vatTaxAmount: item.vatTaxAmount ? item.vatTaxAmount.toFixed(2) : '',
                    additionalTaxAmount: item.additionalTaxAmount ? item.additionalTaxAmount.toFixed(2) : '',
                    individualAmount: item.individualAmount ? item.individualAmount.toFixed(2) : '',
                    earnestAmount: item.earnestAmount ? item.earnestAmount.toFixed(2) : '',
                }
            })
        },
    },
    methods: {
        calcTableHeight() {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    const el = this.$el;
                    if (!el) return;
                    const searchArea = el.querySelector('.search-form-area');
                    const pagination = el.querySelector('.el-pagination');
                    const searchH = searchArea ? searchArea.offsetHeight : 0;
                    const paginationH = pagination ? pagination.offsetHeight : 0;
                    const h = el.clientHeight - searchH - paginationH - 4;
                    if (h > 100) this.tableHeight = h;
                });
            });
        },
        // 统计金额
        getSummaries(param) {

            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }
                if (index === 9) { //指定哪一列合计 如果需要全部合计 去掉这个判断即可
                    sums[9] = this.countNum && this.countNum.money ? Number(this.countNum.money).toFixed(2) : '0.00'
                } else if (index === 10) { //指定哪一列合计 如果需要全部合计 去掉这个判断即可
                    sums[10] = this.countNum && this.countNum.amountPayable ? Number(this.countNum.amountPayable).toFixed(2) : '0.00'
                } else if (index === 11) { //指定哪一列合计 如果需要全部合计 去掉这个判断即可
                    sums[11] = this.countNum && this.countNum.serviceCharge ? Number(this.countNum.serviceCharge).toFixed(2) : '0.00'
                }
            });
            return sums;
        },
        //任务大类请求
        getDropDownData() {
            this.$http.get('sys/plat/ticketPro/page?page=1&limit=1000').then(({ data: res }) => {
                if (res.code == 0) {
                    this.taskList = res.data.list;
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        async handleQuery(isPage) {
            this.pageObject.page = isPage ? this.pageObject.page : 1;
            const countRes = await this.$http.get(`/sys/plat/deal/approval/count`, { params: { ...this.form, taskType: this.form.taskType ? ArrayUtils.getItemBy(this.taskList, 'ticketProject', this.form.taskType).ticketProject : '' } });
            this.countNum = countRes.data.data;
            const res = await this.$http.get(`/sys/plat/deal/approval/isBatchSubmitPage?page=${this.pageObject.page}&taskType=${this.form.taskType ? ArrayUtils.getItemBy(this.taskList, 'ticketProject', this.form.taskType).ticketProject : ''}&limit=${this.pageObject.limit}&money1=${this.form.money1}&money2=${this.form.money2}&dealCode=${this.form.dealCode}&dealBody=${this.form.dealBody}&status=${this.form.status}&dealMonth=${this.form.dealMonth ? this.form.dealMonth : ""}&startDate=${this.form.startDate ? this.form.startDate : ''}&endDate=${this.form.endDate ? this.form.endDate : ''}&paymentDate=${this.form.paymentDate ? this.form.paymentDate : ''}&bodyId=${this.form.bodyId ? this.form.bodyId : ''}`);
            if (res.data.code == 0) {
                this.dataList = res.data.data.list;
                this.pageObject.total = res.data.data.total;
                this.calcTableHeight();
            }
            this.$nextTick(() => {
                if (this.$refs.refTable) {
                    this.$refs.refTable.doLayout();
                }
            });
        },
        //重置
        handleReset() {
            this.form.taskType = '';
            this.form.dealMonth = '';
            this.form.money1 = '';
            this.form.money2 = '';
            this.form.dealCode = '';
            this.form.dealBody = '';
            this.form.status = 3;
            this.form.startDate = '';
            this.form.endDate = '';
            this.form.paymentDate = '';
            this.form.bodyId = '';
            this.handleQuery();
        },
        //收款方信息查看
        handleSee(row) {
            localStorage.setItem(`3${this.$route.name}`, JSON.stringify(this.form))
            const routeParams = {
                routeName: `${this.$route.name}__收款方信息`,
                title: `收款方信息`,
                path: 'plat/batch-settlement-list/content/payee-info',
                params: {
                    id: row.id
                }
            }
            // 动态路由
            addDynamicRoute(routeParams, this.$router)
        },
        //分页
        handlePageSize(val) {
            this.pageObject.page = 1
            this.pageObject.limit = val
            this.handleQuery()
        },
        //当前页数
        handleCurrentPage(val) {
            this.pageObject.page = val
            this.handleQuery(true)
        },
        //选中的表格
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //任务发布编号
        goTaskInfo(id) {
            localStorage.setItem(`3${this.$route.name}`, JSON.stringify(this.form))
            // 路由参数
            const routeParams = {
                routeName: `${this.$route.name}__任务详情`,
                title: `任务详情`,
                path: 'plat/platttask-info',
                params: {
                    id: id
                }
            }
            // 动态路由
            addDynamicRoute(routeParams, this.$router)
        },
        // 合同编号
        infoHandle(row) {
            localStorage.setItem(`3${this.$route.name}`, JSON.stringify(this.form))
            // if(row.bodyId == '1453241566079012865'){
            // 路由参数
            const routeParams = {
                routeName: `${this.$route.name}__合同详情`,
                title: `合同详情`,
                path: 'plat/platcontract-info',
                params: {
                    id: row.contractId
                }
            }
            // 动态路由
            addDynamicRoute(routeParams, this.$router)

            //     }else{
            //     // 路由参数
            //     const routeParams = {
            //         routeName: `${this.$route.name}__合同信息`,
            //         title: `合同信息`,
            //         path: 'user/contractDetail',
            //         params: {
            //             isContractList:true,
            //             id: row.userId,
            //         }
            //     }
            //     // 动态路由
            //     addDynamicRoute(routeParams, this.$router)
            // }
            // 路由参数
            // const routeParams = {
            //     routeName: `${this.$route.name}__合同详情`,
            //     title: `合同详情`,
            //     path: 'plat/platcontract-info',
            //     params: {
            //         id:row.contractId
            //     }
            // }
            // 动态路由
            // addDynamicRoute(routeParams, this.$router)
        },
        // 获取税源地列表
        async getBodyPageList() {
            const res = await this.$http.get('/sys/plat/body/page?page=1&limit=1000', {});
            if (res.data.code !== 0) {
                return this.$message.error(res.msg)
            } else {
                this.bodyPageList = res.data.data.list
            }
        },
    },
    created() {
        this.getBodyPageList();
        this.getDropDownData();
        if (localStorage.getItem(`3${this.$route.name}`)) {
            this.form = JSON.parse(localStorage.getItem(`3${this.$route.name}`))
        }
        this.handleQuery();
    },
    mounted() {
        this.$nextTick(() => { this.calcTableHeight(); });
        window.addEventListener('resize', this.calcTableHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calcTableHeight);
    }
}
</script>
<style lang="scss">
.settlement-tab-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .search-form-area {
        flex-shrink: 0;
    }

    > .el-table {
        flex: 1;
    }

    > .el-pagination {
        flex-shrink: 0;
        padding: 10px 0;
        text-align: right;
    }
}
.selection .cell{
    padding: 0 !important;
}
</style>